import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

export const DROPDOWN_WIDTH = 140;

export const DROPDOWN_HEIGHT = 260;

export const StyledDropdownParent = styled.div<{ width: number }>`
    position: relative;
    min-width: 0;
    width: ${({ width }) => width}px;

    .DropdownButton .DropdownButton-text {
        display: inline-block;
    }

    & .icon-arrow.DropdownButton--triangle {
        color: ${colorsPalettes.carbon[400]};
    }
`;
